import { Injectable } from '@angular/core';
import { Http, Request, RequestMethod, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpRequest } from '../../model/HttpRequest';
import { Logger } from '../../utils/Logger';
import { error } from 'util';
import { element } from 'protractor';
import { URLSearchParams } from '@angular/http';
import { InventoryHistory } from '../../model/InventoryHistory';
import { TaskCode, } from '../../global';
import * as global from '../../global';
import 'rxjs/add/operator/share'

// import * as moment from "moment";

@Injectable()
export class CommonServices {
    method: string;
    constructor(public http: Http) { }
    getApi(httpreq: HttpRequest)
    // tslint:disable-next-line:one-line
    // tslint:disable-next-line:indent
    {

        this.method = httpreq.method;
        let options = new RequestOptions({ headers: httpreq.headers });
        if (this.method === "GET") {
                return this.http.get(httpreq.url, options)
                    .map(res => res.json());
        }
        else if (this.method === "POST") {
            return this.http.post(httpreq.url, httpreq.params, options)
                .map(res => res.json());
        }
        else if (this.method === "PUT") {
            return this.http.put(httpreq.url, httpreq.params, options)
                .map(res => res.json());
        }
        else if (this.method === "DELETE") {
            return this.http.delete(httpreq.url, options)
                .map(res => res.json());
        }
        else if (this.method === "PATCH") {
            return this.http.patch(httpreq.url, httpreq.params, options)
                .map(res => res.json());
        }

    }

    getResponseAsFile() {
        (res => new Blob([res], { type: 'application/vnd.ms-excel' }));

    }

    throwError(error: any) {
        // if (error != "") {
        //     alert("Server Error\n" + error + "\nYou may see dummy data or nothing");
        // }
    }

    callHttpReq(req: HttpRequest) {
        const options = new RequestOptions({ headers: req.headers });
        this.printRequest(req);
        if (req.method === 'GET') {
            this.appendUrlSearchParams(options, req)
            return this.http.get(req.url, options).map(res => res.json()).share();
        } else if (req.method === 'POST') {
            return this.http.post(req.url, req.params, options).map(res => res.json());
        } else if (req.method === 'PATCH') {
            return this.http.patch(req.url, req.params, options)
                .map(res => res.json());
        }
        else if (req.method === 'DELETE') {
            return this.http.delete(req.url, options)
                .map(res => res.json());
        }
    }

    appendUrlSearchParams(options: RequestOptions, req: HttpRequest) {
        if (req.queryParams) {
            const params = new URLSearchParams()
            req.queryParams.keys().forEach(element => {
                const value = req.queryParams.get(element);
                params.append(element, value);
                console.log(element + ", " + value);
            });
            options.params = params;
        }
    }

    printRequest(req: HttpRequest) {
        Logger.log(req.url);
        Logger.log(req.params);
        Logger.log(req.method);
    }

   

    // uploadFile(req: HttpRequest){
    //     const options = new RequestOptions({ headers: req.headers });
    //     return this.http.post(req.url, req.params, options).map(res => res.json());
    // }

    // sendFileRequest(req: HttpRequest){
    //     var xhr = new XMLHttpRequest();
    //     xhr.withCredentials = true;

    //     xhr.addEventListener("readystatechange", function () {
    //     //   if (this.readyState === 4) {
    //     //     console.log(this.responseText);
    //     //   }
    //       console.log(this.responseText);
    //     });

    //     xhr.open('POST', req.url);
    //     xhr.setRequestHeader('content-type', undefined);

    //     // xhr.setRequestHeader('Accept', 'application/json');
    //     // xhr.setRequestHeader('Access-Control-Allow-Origin', '*');


    //     // xhr.setRequestHeader("postman-token", "364163bb-850c-119b-904d-8c4819352c1d");
    //     xhr.send(req.params)
    // }
}
